import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=26a893c6&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a893c6",
  null
  
)

export default component.exports